import { c as _c } from "react/compiler-runtime";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { Feature2DPhotos } from "@pages/project-details/project-settings/feature-2d-photos";
import { FeatureFaceBlurring } from "@pages/project-details/project-settings/feature-face-blurring";
import { FeatureVideoMode } from "@pages/project-details/project-settings/feature-video-mode";
import { FeatureAiIndexing } from "@pages/project-details/project-settings/feature-ai-indexing";
import { BaseSettingsPage } from "@pages/settings/base-settings-page";
import { SettingDisplayForViewers } from "@src/pages/project-details/project-settings/setting-display-for-viewers";
import { fetchingProjectsFlagsSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { useMemo } from "react";
import { ExportProjectData } from "@pages/project-details/project-settings/export-project-data";
/** Renders the settings tab in project details page */
export function ProjectSettings(t0) {
  const $ = _c(44);
  const {
    projectId,
    isLoading
  } = t0;
  const {
    isFetchingProjectContext,
    isFetchingProjectSettings
  } = useAppSelector(fetchingProjectsFlagsSelector);
  const {
    canView2dImagesFeature,
    canViewVideoModeFeature,
    canViewFaceBlurringFeature,
    canViewAiIndexingFeature
  } = useHasValidFeatureProjectLevel();
  const {
    canViewProjectSettings
  } = useHasUserValidPermissionProjectLevel();
  const isLoadingFeatures = isLoading || isFetchingProjectContext;
  const isLoadingSettings = isLoading || isFetchingProjectSettings;
  const t1 = !canView2dImagesFeature;
  const t2 = projectId ?? "";
  let t3;
  if ($[0] !== t2) {
    t3 = <Feature2DPhotos projectId={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = {
      shouldContentTakeFullWidth: true,
      shouldLabelBold: true,
      shouldAddRightPadding: true,
      isHidden: t1,
      content: t3
    };
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !canViewVideoModeFeature;
  const t6 = projectId ?? "";
  let t7;
  if ($[5] !== t6) {
    t7 = <FeatureVideoMode projectId={t6} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t5 || $[8] !== t7) {
    t8 = {
      shouldContentTakeFullWidth: true,
      shouldAddRightPadding: true,
      shouldLabelBold: true,
      isHidden: t5,
      content: t7
    };
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = !canViewFaceBlurringFeature;
  const t10 = projectId ?? "";
  let t11;
  if ($[10] !== t10) {
    t11 = <FeatureFaceBlurring projectId={t10} />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t9) {
    t12 = {
      shouldContentTakeFullWidth: true,
      shouldLabelBold: true,
      shouldAddRightPadding: true,
      isHidden: t9,
      content: t11
    };
    $[12] = t11;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = !canViewAiIndexingFeature;
  const t14 = projectId ?? "";
  let t15;
  if ($[15] !== t14) {
    t15 = <FeatureAiIndexing projectId={t14} />;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t13 || $[18] !== t15) {
    t16 = {
      shouldContentTakeFullWidth: true,
      shouldLabelBold: true,
      shouldAddRightPadding: true,
      isHidden: t13,
      content: t15
    };
    $[17] = t13;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t12 || $[21] !== t16 || $[22] !== t4 || $[23] !== t8) {
    t17 = [t4, t8, t12, t16];
    $[20] = t12;
    $[21] = t16;
    $[22] = t4;
    $[23] = t8;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== isLoadingFeatures || $[26] !== t17) {
    t18 = {
      title: "Project Features",
      subtitle: "These are the available features for your project. \n      Adjust them here to fit your needs by using the toggles.",
      isLoading: isLoadingFeatures,
      items: t17
    };
    $[25] = isLoadingFeatures;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = !canViewProjectSettings;
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <SettingDisplayForViewers />;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t19) {
    t21 = [{
      shouldContentTakeFullWidth: true,
      shouldLabelBold: true,
      shouldAddRightPadding: true,
      isHidden: t19,
      content: t20
    }];
    $[29] = t19;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== isLoadingSettings || $[32] !== t21) {
    t22 = {
      title: "Annotations visibility",
      subtitle: "By selecting this option, permission to view annotations will be granted to all \"Viewers\" of this project.",
      isLoading: isLoadingSettings,
      items: t21
    };
    $[31] = isLoadingSettings;
    $[32] = t21;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t18 || $[35] !== t22) {
    t23 = [t18, t22];
    $[34] = t18;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  const pageSectionsProps = t23;
  let t24;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      mt: "45px"
    };
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== isLoading || $[39] !== pageSectionsProps) {
    t25 = <BaseSettingsPage pageSectionProps={pageSectionsProps} isLoading={isLoading} dataTestId="WORKSPACE_SETTING_CONTAINER" customSx={t24} />;
    $[38] = isLoading;
    $[39] = pageSectionsProps;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <ExportProjectData />;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t25) {
    t27 = <>{t25}{t26}</>;
    $[42] = t25;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  return t27;
}